import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'maskAccountNumber',
})
export class MaskAccountNumberPipe implements PipeTransform {
  transform(value: any): any {
    value = value ? value.toString() : value;
    if (value != null || value != undefined) {
      if (value.length > 4) {
        return 'XXXX' + value.substr(value.length - 4, value.length);
      } else {
        return 'XXXX' + value;
      }
    }
  }
}
